import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <footer className="footerWrapper">
                <div className="innerWrapper">
                    <div className="infoWrapper">
                        <div className="copyright">
                            <span>Copyright 2018 Beacon English</span>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Containers/Footer/index.js